import type { DeliveryCity, DeliveryPoint } from '@/entities/order/types/delivery'

import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'

type GetDeliveryPointInfoParams = {
	pvzCode: string
	pvzPartner: string
}

export type DeliveryPointInfo = {
	DELIVERY_PRICE: string
	DELIVERY_DATE: string
}

export const pvzApiSlice = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getPvzPoints: builder.query<DeliveryPoint | null, { fiasId: string }>({
			query: ({ fiasId }) => ({
				url: `delivery/map/point/${fiasId}`
			}),
			transformResponse: (res: ServerResponse<DeliveryPoint>) => {
				if (!res?.data) return null
				return res?.data
			}
		}),
		findDeliveryCity: builder.query<DeliveryCity[], { cityName: string }>({
			query: data => ({
				url: `delivery/cities`,
				params: {
					CITY_NAME: data?.cityName
				}
			}),
			transformResponse: (res: ServerResponse<DeliveryCity[]>): DeliveryCity[] => {
				if (!res?.data?.length) return []
				return res?.data
			}
		}),
		getPointInfo: builder.query<DeliveryPointInfo, GetDeliveryPointInfoParams>({
			query: ({ pvzCode, pvzPartner }) => {
				return {
					url: `delivery/map/calculate/${pvzCode}`,
					params: {
						DELIVERY_PVZ_PARTNER: pvzPartner
					}
				}
			},
			transformResponse: (res: ServerResponse<DeliveryPointInfo>): DeliveryPointInfo => {
				if (!res?.data) return null

				return res?.data
			}
		})
	})
})

export const { useLazyFindDeliveryCityQuery, useGetPvzPointsQuery, useLazyGetPointInfoQuery } = pvzApiSlice
